import { Link } from 'react-router-dom';
import SiteHeader from '@/components/layout/SiteHeader/SiteHeader';
import SiteFooter from '@/components/layout/SiteFooter/SiteFooter';
import { usePageSeo } from '@/hooks/usePageSeo';
import styles from './NotFound.module.css';

export default function NotFound() {
  usePageSeo({ noindex: true });
  return (
    <>
      <SiteHeader variant="lp" />
      <main className={styles.main}>
        <div className={styles.inner}>
          <div className={styles.eyebrow}>404 ── ページが見つかりません</div>
          <h1 className={styles.title}>
            そのページは、見当たりませんでした。
          </h1>
          <p className={styles.desc}>
            お探しのページは、移動したか、もうないかもしれません。トップから、もう一度ご案内します。
          </p>
          <div className={styles.actions}>
            <Link to="/" className={styles.primary}>
              トップへ戻る
            </Link>
            <Link to="/report" className={styles.secondary}>
              立地レポートを開く
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
